import manager1 from '../assets/manager-lyudmila.jpg';
import manager2 from '../assets/manager-marina.jpg';
import manager3 from '../assets/manager-alya.jpg';
import manager4 from '../assets/manager-irina.jpg';
import manager5 from '../assets/manager-komila.jpg';

export const managers = [
  {
    id: 1,
    name: 'Людмила',
    phone: '+998 90 988 11 89',
    telegram: 'https://t.me/Lyudmila_asiantour',
    photo: manager1,
  },
  {
    id: 2,
    name: 'Марина',
    phone: '+998 90 905 81 89',
    telegram: 'https://t.me/mariwariwa',
    photo: manager2,
  },
  {
    id: 3,
    name: 'Алия',
    phone: '+998 90 188 66 76',
    telegram: 'https://t.me/AsianTourPlus_Alya',
    photo: manager3,
  },
  {
    id: 4,
    name: 'Ирина',
    phone: '+998 97 709 93 11',
    telegram: 'https://t.me/iruttakamalova',
    photo: manager4,
  },
  {
    id: 5,
    name: 'Комила',
    phone: '+998 90 018 11 33',
    telegram: 'https://t.me/asiantour_komila',
    photo: manager5,
  },
];

export const managerByName = Object.fromEntries(managers.map((m) => [m.name, m]));
